export default "__VITE_ASSET__CEZBPird__"